import { trackingHealthCopy as t } from "./copy.ts";

export const steps = { paginas: t.passo };
